import React from 'react';
import { ContainerDesktop, ContainerDate, TitleDesktop, SeletorData } from './styles';
import { Props } from './types';
import { DatePicker } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import type { RangePickerProps } from 'antd/es/date-picker';
import { CALENDAR_LOCALE } from '../../../../../utils/calendar-locale';
import { useWindowSize } from '../../../../../hook/useWindowSize';
// import FilterMobile from './Mobile';
import { dashSlaRequest } from '../../../../../store/ducks/dashSlaAtendimento/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import moment from 'moment';

const Filter: React.FC<Props> = () => {
  const { RangePicker } = DatePicker;
  const { width }: any = useWindowSize();
  const dispatch = useDispatch();
  const cd = useSelector((state: ApplicationState) => state.auth?.cddAtivo?.codCdd) as number;
  const inscricoes = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);

  const handleChange: RangePickerProps['onChange'] = (date) => {
    if (date) {
      const initialDate = date && moment(date[0]).format();
      const finalDate = date && moment(date[1]).format();
      dispatch(dashSlaRequest(initialDate, finalDate, cd, inscricoes));
    }
  };

  const handleSelect = (e: any) => {
    switch (e.innerText) {
      case 'Dia':
        dispatch(dashSlaRequest(moment().format(), moment().format(), cd, inscricoes));
        localStorage.setItem('filterDashboard', moment().format());
        break;
      case 'Semana':
        dispatch(
          dashSlaRequest(moment().subtract(7, 'days').format(), moment().format(), cd, inscricoes)
        );
        localStorage.setItem('filterDashboard', moment().subtract(7, 'days').format());
        break;
      case 'Mês':
        dispatch(
          dashSlaRequest(moment().subtract(1, 'months').format(), moment().format(), cd, inscricoes)
        );
        localStorage.setItem('filterDashboard', moment().subtract(1, 'months').format());
        break;
      case 'Ano':
        dispatch(
          dashSlaRequest(moment().subtract(1, 'years').format(), moment().format(), cd, inscricoes)
        );
        localStorage.setItem('filterDashboard', moment().subtract(1, 'years').format());
        break;
      default:
        break;
    }
  };

  const handleClickItem = (e: any, calbackFunction: CallableFunction) => {
    const array = document.querySelectorAll('.itens');
    array.forEach((item) => {
      item?.classList?.remove('active');
    });
    e?.classList.add('active');
    calbackFunction(e);
  };

  return (
    <div>
      {width > 768 && (
        <ContainerDesktop className="themeSLA">
          <TitleDesktop>
            <div>Filtros</div> <ArrowRightOutlined className="icon" />
          </TitleDesktop>

          <ContainerDate>
            <ul className="ContainerOptions">
              <li
                onClick={(e) => handleClickItem(e.target, handleSelect)}
                className="itens active"
                role="menuitem"
              >
                Dia
              </li>
              <li
                onClick={(e) => handleClickItem(e.target, handleSelect)}
                className="itens"
                role="menuitem"
              >
                Semana
              </li>
              <li
                onClick={(e) => handleClickItem(e.target, handleSelect)}
                className="itens"
                role="menuitem"
              >
                Mês
              </li>
              <li
                onClick={(e) => handleClickItem(e.target, handleSelect)}
                className="itens"
                role="menuitem"
              >
                Ano
              </li>
            </ul>

            <SeletorData>
              <RangePicker
                onChange={handleChange}
                format={CALENDAR_LOCALE.dateFormat}
                data-testid="seletor-data"
                disabledDate={(current) => {
                  return current && current > moment().endOf('day');
                }}
              />
            </SeletorData>
          </ContainerDate>
        </ContainerDesktop>
      )}
    </div>
  );
};

export default Filter;
